import React from 'react';
import { Button } from '../components/ui/button';
import { Globe2 } from 'lucide-react';

/**
 * Shown before first visit when no language is stored.
 * Skip defaults to English. Review/testimonial content is unchanged site-wide.
 */
const LanguageGate = ({ onChooseEnglish, onChooseTelugu, onSkip }) => (
  <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-gradient-to-br from-[#0f2540] via-[#0f2540] to-[#14A098] text-white">
    <div className="w-16 h-16 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center mb-6 border border-white/20">
      <Globe2 className="w-9 h-9 text-teal-200" aria-hidden />
    </div>
    <h1 className="text-2xl md:text-3xl font-extrabold text-center mb-2 tracking-tight">
      Welcome to SolveTax
    </h1>
    <p className="text-lg md:text-xl text-teal-100 text-center font-medium mb-1">
      సాల్వ్‌టాక్స్‌కు స్వాగతం
    </p>
    <p className="text-sm text-teal-100/90 text-center max-w-md mb-10 leading-relaxed">
      Choose your language to continue. You can change it later from the top menu.
      <span className="block mt-2 text-teal-50/95">
        కొనసాగడానికి భాషను ఎంచుకోండి. పై మెనూలో తర్వాత మార్చుకోవచ్చు.
      </span>
    </p>

    <div className="flex flex-col sm:flex-row gap-3 w-full max-w-sm">
      <Button
        type="button"
        onClick={() => onChooseEnglish()}
        className="h-12 rounded-full bg-white text-[#0f2540] hover:bg-teal-50 font-semibold shadow-lg"
      >
        English
      </Button>
      <Button
        type="button"
        onClick={() => onChooseTelugu()}
        className="h-12 rounded-full bg-[#14A098] hover:bg-[#0e7a74] text-white border-2 border-white/30 font-semibold shadow-lg"
      >
        తెలుగు (Telugu)
      </Button>
    </div>
    <button
      type="button"
      onClick={() => onSkip()}
      className="mt-6 text-sm text-teal-100 underline underline-offset-4 hover:text-white transition-colors"
    >
      Skip — continue in English
    </button>
    <p className="mt-8 text-[11px] text-teal-200/70 text-center max-w-sm">
      Client reviews on the home page stay in English, Telugu and Hindi as written by real customers.
    </p>
  </div>
);

export default LanguageGate;
